import { useSelector } from "react-redux";
import type { RootState } from "../../store";
import type { Ticket, UserLimitedList, Services } from "../../generated-axios-client";

type WorkOrdersState = {
  tickets: Ticket[];
  assigneeById: Record<number, UserLimitedList>;
  serviceById: Record<string, Services>;
  loading: boolean;
  error: string | null;
};

export function useDashboardWorkOrders(): WorkOrdersState {
  const tickets = useSelector((state: RootState) => state.dashboard.tickets);
  const assigneeById = useSelector((state: RootState) => state.dashboard.assigneeById);
  const serviceById = useSelector((state: RootState) => state.dashboard.serviceById);
  const loading = useSelector((state: RootState) => state.dashboard.loading);
  const error = useSelector((state: RootState) => state.dashboard.error);
  return { tickets, assigneeById, serviceById, loading, error };
}
